import styled from 'styled-components'
import { ColorsEnum } from 'types/cssTypes'
import { IChildrenNode } from 'types/propTypes'

interface IProps extends IChildrenNode {
  activeLinkThemeColor?: keyof typeof ColorsEnum
}

export const TopNav = ({ children, activeLinkThemeColor }: IProps) => {
  return (
    <Wrapper activeLinkThemeColor={activeLinkThemeColor} data-testid="top-nav">
      {children}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ activeLinkThemeColor?: keyof typeof ColorsEnum }>`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  height: 100%;

  a {
    ${({ theme }) => theme.typography.m.normal};
    padding: 1rem 0.25rem;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    letter-spacing: 0.5px;
    font-weight: ${({ theme }) => theme.fontWeight.medium};

    &:not(.active):hover {
      color: ${({ theme }) => theme.colors.primary.dark};
    }

    &.active {
      color: ${({ theme, activeLinkThemeColor }) =>
        activeLinkThemeColor ? theme.colors?.[activeLinkThemeColor]?.dark : theme.colors.primary.darker};
      font-weight: ${({ theme }) => theme.fontWeight.medium};
      position: relative;

      &::after {
        content: '';
        position: absolute;
        display: block;
        bottom: -0.2px;
        left: -0.1rem;
        right: -0.1rem;
        border-bottom: 0.25rem solid
          ${({ theme, activeLinkThemeColor }) =>
            activeLinkThemeColor ? theme.colors?.[activeLinkThemeColor]?.neutral : theme.colors.primary.dark};
        border-radius: 0.5rem 0.5rem 0 0;
      }
    }
  }
`
